import { initializeApp } from "firebase/app";
import firebaseConfig from "./firebaseConfig";

import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const app = initializeApp(firebaseConfig);

// ✅ Auth (always safe)
export const auth = getAuth(app);


// ⚠️ Analytics (only works in browser, not SSR)
export let analytics: any = null;

isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

export default app;